import type {
  GamePlayerProjectionsRequest,
  ProjectionsAndScoresAPIResponse
} from '@library/types/projection';
import type { PlayerPackResponse } from '@library/types/playerPacks/playerPacks';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';

const { admin } = apiPaths;

export const playerPackApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProjectionsForPlayerPacks: build.query<
      ProjectionsAndScoresAPIResponse,
      GamePlayerProjectionsRequest
    >({
      query: ({
        demonsAndGoblins = undefined,
        durationId,
        fromDate,
        gameId = undefined,
        leagueId,
        page = 1,
        perPage = 300,
        search = undefined,
        statTypeIds = undefined,
        team,
        toDate = undefined
      }) => ({
        url: `${admin}projections`,
        method: 'GET',
        params: {
          demons_and_goblins: demonsAndGoblins,
          duration_id: durationId,
          from_date: fromDate,
          to_date: toDate,
          game_ids: gameId,
          game_mode_ids: [1],
          league_id: leagueId,
          page,
          per_page: perPage,
          search,
          stat_type_ids: statTypeIds,
          statuses: ['pre_game,suspended'],
          teams: team
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
    }),
    createPlayerPack: build.mutation<PlayerPackResponse, FormData>({
      query: (formData) => ({
        url: `${admin}player_packs`,
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'multipart/form-data'
        }
      })
    }),
    updatePlayerPack: build.mutation<void, { id: string; formData: FormData }>({
      query: ({ id, formData }) => ({
        url: `${admin}player_pack/${id}`,
        method: 'PATCH',
        body: formData,
        headers: {
          Accept: 'multipart/form-data'
        }
      })
    }),
    deletePlayerPack: build.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `${admin}player_pack/${id}`,
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    })
  })
});

export const {
  useGetProjectionsForPlayerPacksQuery,
  useCreatePlayerPackMutation,
  useUpdatePlayerPackMutation,
  useDeletePlayerPackMutation
} = playerPackApi;
